<template>
    <div>
        <card card-body-classes="table-full-width px-4 pb-3" no-footer-line>
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <h4>{{ $t("app.cart.title") }}</h4>
                        <div class="row">
                            <!--Combo direcciones-->

                            <div class="col-12">
                                <div class="form-group" v-if="cartCount">
                                    <img src="/img/icons/Numbers-1-Black-icon.png" title="number1" alt="number1" />
                                    &nbsp;
                                    <label>{{ $t("app.cart.selectshippingaddress") }}</label>

                                    <el-select :placeholder="$t(
                                        'app.modules.product_family_detail.headers.select_address'
                                    )
                                        " size="large" v-model="idDireccion" @change="changeOption">
                                        <el-option v-for="(ad, index) in addresses" :key="'address-' + index"
                                            :label="ad.direccionString" :value="ad.idDireccion">
                                        </el-option>
                                    </el-select>
                                </div>
                            </div>

                            <div class="col-12">
                                <div class="form-group" v-if="cartCount">
                                    <img src="/img/icons/Numbers-2-Black-icon.png" title="number2" alt="number2" />
                                    &nbsp;
                                    <label>{{
                                        $t(
                                            "app.modules.product_family_detail.headers.check_quantity"
                                        )
                                    }}</label>
                                </div>
                            </div>

                            <div class="col-12">
                                <cart-list :isDropDown="false" ref="list" v-on:list1="recibeDatos"
                                    :editable="isNotEdit"></cart-list>
                            </div>

                            <card card-body-classes="table-full-width px-4 pb-3" no-footer-line v-if="cartCount">
                                <div class="row form-group">
                                    <div class="col-12">
                                        <img src="/img/icons/Numbers-3-Black-icon.png" title="number2" alt="number2" />
                                        &nbsp;
                                        <label>{{
                                            $t(
                                                "app.modules.product_family_detail.headers.add_purchase"
                                            )
                                        }}</label>
                                    </div>

                                    <label class="col-form-label col-12">{{
                                        $t("app.cart.purchaseOrder")
                                    }}</label>
                                    <div class="col-12">
                                        <template>
                                            <ValidationProvider rules="max:35" v-slot="{ passed, failed }">
                                                <fg-input type="text" :error="failed
                                                            ? $t('app.promps.cart.maxPurchaseOrderLength')
                                                            : null
                                                        " :placeholder="$t('app.cart.purchaseOrder')"
                                                    v-model="ordenCompraStr" :disabled="isNotEdit">
                                                </fg-input>
                                            </ValidationProvider>
                                        </template>
                                    </div>
                                    <div class="col-12">
                                        <file-input :input-props="{ accept: 'application/pdf' }" :inputName="inputName"
                                            v-model="files" />
                                    </div>
                                </div>
                            </card>

                            <div class="col-12" v-if="cartCount">
                                <n-button class="btn btn-primary pull-right" @click.native="confirmFinishOrder()"
                                    v-if="!isNotEdit">
                                    {{ $t("app.cart.finishOrder") }}</n-button>

                                <n-button class="btn btn-primary pull-right" round @click.native="cancel()"
                                    v-if="isNotEdit">{{ $t("app.cart.cancel") }}
                                </n-button>

                                <n-button class="btn btn-primary pull-right" @click.native="saveCart()" v-if="!isNotEdit">
                                    {{ $t("app.cart.savecart") }}</n-button>

                                <n-button class="btn btn-primary pull-right" @click.native="guardarPedido()"
                                    v-if="isNotEdit">
                                    {{ $t("app.cart.requestOrder") }}</n-button>

                                <n-button class="btn btn-primary pull-right" round
                                    @click.native="$router.push({ path: 'add-by-part-number' })" v-if="!isNotEdit">{{
                                        $t("app.cart.ShoppingCart") }}
                                </n-button>

                                <n-button class="btn btn-primary pull-right"
                                    @click.native="$router.push({ path: 'add-by-part-number' })" v-if="isNotEdit">
                                    {{ $t("app.cart.keepBuying") }}</n-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </card>

        <!--
    <card card-body-classes="table-full-width px-4 pb-3" no-footer-line v-if="cartCount">
      <div class="row form-group">
        <label class="col-form-label col-12">{{$t('app.cart.purchaseOrder')}}</label>
        <div class="col-12">
          <template>
            <ValidationProvider rules="max:35" v-slot="{ passed, failed }">
              <fg-input
                type="text"
                :error="failed ? $t('app.promps.cart.maxPurchaseOrderLength') : null"
                :placeholder="$t('app.cart.purchaseOrder')"
                v-model="ordenCompraStr"
              >
              </fg-input>
            </ValidationProvider>
          </template>
        </div>
        <div class="col-12">
          <file-input :input-props="{accept: 'application/pdf'}" v-model="files"/>
        </div>
      </div>
    </card>
    -->
    </div>
</template>

<script>
import Swal from "sweetalert2";
import FileInput from "@/components/Inputs/FileInput";
import {
    mapState
} from "vuex";
import ListaCarrito from "../cart/cartList";
import {
    getResponse,
    number_format
} from "@/util/utilities";
import moment from 'moment';

export default {
    name: "CartPedidoPage",
    components: {
        CartList: () => import("../cart/cartList"),
        FileInput,
    },
    computed: {
        ...mapState(["lang"]),
        cartCount() {
            if (this.list) {
                if (this.list.cartItems.length > 99) {
                    return "+99";
                }
                if (this.list.cartItems.length) {
                    return this.list.cartItems.length.toString();
                }
            }
            return null;
        },
    },
    data() {
        return {
            files: [],
            ordenCompraStr: "",
            orden: undefined,
            saveAsPedidoModelo: false,
            nombrePedidoModelo: "",
            list: undefined,
            addresses: [],
            idDireccion: 0,
            price: 0,
            moneda: "",
            unidad: "",
            idPedido: 0,
            isNotEdit: false,
            irACarrito: false,
            saveCartButton: true,
            inputName: "",
            errorValidate: false
        };
    },

    async mounted() {

        this.list = this.$refs.list;

        await this.init();

        
        setTimeout(() => {
            this.loadPrecio()
        }, 1000);

        
    },
    updated() {
        this.list = this.$refs.list;
    },
    /*
    created() {
        // console.log(this.$route.query.source);
        var source = this.$route.query.source;
        if (source == "bot") {
            EventBus.$emit("load-cart-items");
        }
    },*/
    methods: {
        recibeDatos(cartList) {
            //console.log("Entra a recibeDatos");

            /*console.log(
                "Valor de length cartList recibe datos --> " + JSON.stringify(cartList)
            );*/

            if (cartList.length > 0) {

                //console.log("ENTRO A CARTLIST > 0")
                /*
                console.log(
                  "Valor de orden cartList --> " +
                    JSON.stringify(cartList[0].ordenCompraStr)
                );

                console.log(
                  "Valor de orden this  --> " + JSON.stringify(this.ordenCompraStr)
                );

                console.log(
                  "Valor de orden cartList leng --> " +
                    JSON.stringify(cartList[0].ordenCompraStr.length)
                );

                console.log(
                  "Valor de idDireccion cartList --> " +
                    JSON.stringify(cartList[0].producto.direccionEntrega.idDireccion)
                );*/

                if (cartList[0].ordenCompraStr.length > 0) {
                    //console.log("Entro a mayor que length");
                    this.ordenCompraStr = cartList[0].ordenCompraStr;
                } else {
                    //console.log("Entro a diferente que length");
                    this.ordenCompraStr = this.ordenCompraStr;
                }



                //this.ordenCompraStr = cartList[0].ordenCompraStr;
                this.idDireccion = cartList[0].producto.direccionEntrega.idDireccion;
                this.idPedido = cartList[0].idPedido;
                this.inputName = cartList[0].ordenCompraCliente.split("//")[1];
            }

            /*
            console.log(
              "Valor de orden cartList --> " +
                JSON.stringify(cartList[0].ordenCompraStr)
            );

            /*

            if (cartList[0].ordenCompraStr != "") {
              this.ordenCompraStr = cartList[0].ordenCompraStr;
            } else {
              console.log(
                "Valor de orden cartList en else --> " +
                  JSON.stringify(this.ordenCompraStr)
              );

              this.ordenCompraStr = this.ordenCompraStr;
            }

            if (cartList[0].producto.direccionEntrega.idDireccion != "") {
              this.idDireccion = cartList[0].producto.direccionEntrega.idDireccion;
            } else {
              console.log(
                "Valor de orden cartList en else --> " +
                  JSON.stringify(this.idDireccion)
              );

              this.idDireccion = this.idDireccion;
            }

            if (cartList[0].idPedido != "") {
              this.idPedido = cartList[0].idPedido;
            } else {
              console.log(
                "Valor de orden cartList en else --> " +
                  JSON.stringify(this.idDireccion)
              );

              this.idPedido = this.idPedido;
            }

            */
        },
        async init() {
            this.$swal.fire({
                title: this.$t("app.promps.wait"),
                html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                showConfirmButton: false,
            });

            await this.obtenerDirec();



            this.$swal.close();
        },
        async obtenerDirec() {
            if (this.$store.state.user.idClienteSAP > 0) {
                let paramClient = {
                    clienteId: this.$store.state.user.idClienteSAP,
                };
                let requestDir = await this.$http.post(
                    route("Clientes/getDireccionesByCliente"),
                    paramClient
                );
                let responseDir = getResponse(requestDir);

                if (responseDir != null) {
                    this.addresses = responseDir.direcciones;
                    this.addresses.unshift({
                        idDireccion: 0,
                        direccionString: "Select address",
                    });
                }
            }
        },
        cancel() {
            this.isNotEdit = false;
        },
        async confirmFinishOrder() {
            try {
                //console.log("**** confirmFinishOrder ****");
                //console.log("this.idPedido  --> " + this.idPedido);

                let saveCart = true;
                let messageError = false;

                this.saveCartButton = false;
                
                saveCart = await this.saveCart();

                //TODO:NEWTON
                //if (this.idPedido == 0) {
                  //  saveCart = await this.saveCart();
                //}

                //console.log("Valor de SAVECART ******* --> " + JSON.stringify(saveCart));

                if (saveCart) {

                    //messageError = await this.loadPrecio();

                    //if (!messageError) {

                    //messageError = setTimeout(() => {
                    //  this.loadPrecio()
                    //}, 1000);

                    //TODO:NEW
                    //messageError = await this.loadPrecio();

                    if (!messageError) {

                        this.validateconfirmOrder();
                        this.isNotEdit = true;
                    }



                    //}

                }
            } catch (e) {
                this.notifyMessage("danger", e.message);
            }
        },
        async guardarPedido() {
            try {
                let confirmOrder = await this.confirmOrder();

                if (confirmOrder.isConfirmed) {
                    this.enviarPedido();
                }
            } catch (e) {
                this.notifyMessage("danger", e.message);
            }
        },
        async saveCart() {
            
            //console.log("saveCartButton --> " + this.saveCartButton);

            let saveCart = false;
            let messageError = false;

            try {


                messageError = await this.loadPrecio();

                //console.log("valor de messageError  ---> " + JSON.stringify(messageError));


                if (!messageError) {

                    if (this.ordenCompraStr.length == 0) {
                        //console.log("orderComprastr --> " + "'" + this.ordenCompraStr + "'");
                        saveCart = false;
                        throw new Error(this.$t("app.cart.promps.purchaseOrderRequired"));
                    }

                    /*
                    console.log(
                        "idDireccion length --> " + JSON.stringify(this.idDireccion)
                    );*/

                    if (this.idDireccion == 0) {
                        //console.log("orderComprastr --> " + "'" + this.ordenCompraStr + "'");
                        saveCart = false;
                        throw new Error(
                            this.$t("app.modules.product_family_detail.errors.no_direction")
                        );
                    }


                    this.showLoader();
                    let data = new FormData();
                    let payload = {
                        ordenCompraStr: this.ordenCompraStr,
                        saveAsPedidoModelo: this.saveAsPedidoModelo,
                        nombrePedidoModelo: this.nombrePedidoModelo,
                        saveAsPedidoSAP: false,
                        idPedido: this.idPedido,
                        buttonSavePedido: true,
                    };
                    data.append("files", this.orden);
                    data.append("param", JSON.stringify(payload));

                    //console.log("antes de agregrar pedido web");


                    await this.$http.post(route("Pedidos/AddPedidoWeb"), data).then(
                        (response) => {
                            this.closeLoader();

                            if (this.saveCartButton) {
                                if (response.body.code === 200) {
                                    //console.log("respuesta correcta");

                                    Swal.fire({
                                        
                                        text: this.$t("app.cart.messages.saved_order"),
                                        type: "success",
                                        confirmButtonClass: "btn btn-success",
                                        buttonsStyling: false,
                                    });
                                    this.loadItems();
                                    saveCart = true;

                                    
                                } else {
                                    console.log(response.body.error);
                                    saveCart = false;
                                    this.notifyMessage("danger", response.body.message);
                                }
                            } else {
                                if (response.body.code === 200) {
                                    //console.log("respuesta correcta");

                                    this.loadItems();
                                    saveCart = true;

                                    //TO-DO: Comente siguiente linea, validar si se tiene que dejar o no
                                    //this.$router.push({ name: "Añadir por Numero de Parte" });

                                    //this.files = [];
                                    //this.ordenCompraStr = "";
                                    //this.orden = undefined;
                                } else {
                                    //console.log(response.body.error);
                                    saveCart = false;
                                    this.notifyMessage("danger", response.body.message);
                                }
                            }
                        },
                        (error) => {
                            this.closeLoader();
                            //console.log(error);
                            saveCart = false;
                            this.notifyMessage("danger", this.$t("app.promps.error"));
                        }
                    );


                }
            } catch (e) {
                this.notifyMessage("danger", e.message);
            }

            this.saveCartButton = true;

            return saveCart;
        },
        async enviarPedido() {
            //console.log("Entra a enviar");
            this.showLoader();
            let data = new FormData();
            let payload = {
                ordenCompraStr: this.ordenCompraStr,
                saveAsPedidoModelo: this.saveAsPedidoModelo,
                nombrePedidoModelo: this.nombrePedidoModelo,
                saveAsPedidoSAP: true,
                idPedido: this.idPedido,
                buttonSavePedido: false,
            };
            data.append("files", this.orden);
            data.append("param", JSON.stringify(payload));

            await this.$http.post(route("Pedidos/AddPedidoWeb"), data).then(
                (response) => {
                    this.closeLoader();
                    if (response.body.code === 200) {
                        Swal.fire({
                            title: this.$t("app.cart.messages.sended"),
                            text: "YOUR ORDER NUMBER: " + response.body.message + " HAS BEEN SENT AND IT WILL PROCESS SOON",
                            type: "success",
                            confirmButtonClass: "btn btn-success",
                            buttonsStyling: false,
                        }).then((result) => {
                            if (result.value) {
                                this.loadItems();
                                this.files = [];
                                this.ordenCompraStr = "";
                                this.orden = undefined;

                                this.$router.push({
                                    name: "Añadir por Numero de Parte",
                                });
                            }
                        });

                        /*
                        this.loadItems();
                        this.files = [];
                        this.ordenCompraStr = "";
                        this.orden = undefined;

                        this.$router.push({
                          name: "Añadir por Numero de Parte",
                        });*/
                    } else {
                        //console.log(response.body.error);
                        this.notifyMessage("danger", response.body.message);
                    }
                },
                (error) => {
                    this.closeLoader();
                    //console.log(error);
                    this.notifyMessage("danger", this.$t("app.promps.error"));
                }
            );
        },
        loadItems() {
            EventBus.$emit("load-cart-items");

            //this.ordenCompraStr = this.list.cartItems[0].ordenCompraStr;
        },
        showLoader() {
            this.$swal.fire({
                title: this.$t("app.promps.wait"),
                html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                showConfirmButton: false,
            });
        },
        closeLoader() {
            this.$swal.close();
        },
        confirmOrder() {
            //var algo = document.getElementById("paimprimir");

            return Swal.fire({
                title: this.$t("app.cart.messages.confirm_order"),
                //text: this.$t("app.cart.messages.confirm_order_text"),
                //html: algo.innerHTML,
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                cancelButtonClass: "btn btn-danger",
                confirmButtonText: this.$t("app.cart.messages.confirm_order_button"),
                cancelButtonText: this.$t("app.cart.messages.cancel_order_button"),
                buttonsStyling: false,
            });
        },
        validateconfirmOrder() {
            return Swal.fire({
                text: this.$t("app.cart.messages.validate_confirm_order_text"),
                type: "success",
                confirmButtonClass: "btn btn-success",
                buttonsStyling: false,
            });
        },
        confirmSaveOrderModel() {
            return Swal.fire({
                title: this.$t("app.cart.messages.save_order_model"),
                text: this.$t("app.cart.messages.save_order_model_text"),
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                cancelButtonClass: "btn btn-danger",
                confirmButtonText: this.$t("app.buttons.yes"),
                cancelButtonText: this.$t("app.buttons.no"),
                buttonsStyling: false,
            });
        },
        nameOrderModel() {
            let self = this;
            return Swal.fire({
                title: this.$t("app.cart.messages.new_order_model"),
                input: "text",
                inputPlaceholder: this.$t("app.cart.headers.name_order_model"),
                type: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success",
                cancelButtonClass: "btn btn-danger",
                confirmButtonText: this.$t("app.buttons.save"),
                cancelButtonText: this.$t("app.buttons.cancel"),
                buttonsStyling: false,
                inputValidator: (value) => {
                    return new Promise((resolve) => {
                        if (value.length === 0) {
                            resolve(self.$t("app.cart.errors.no_name_order_model"));
                        } else resolve();
                    });
                },
            });
        },
        changeOption() {
            this.loadPrecio();
        },
        async loadPrecio() {

            if (this.idDireccion > 0) {


                let errors = [];
                let validItems = [];
                let messageError = false;


                this.$swal.fire({
                    title: this.$t("app.promps.wait"),
                    html: '<div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status"><span class="sr-only">Loading...</span></div>',
                    showConfirmButton: false,
                });

                


                if (this.list.cartItems.length > 0) {
                    
                    let param = {
                        direccionId: this.idDireccion,
                        clienteIdSAP: this.$store.state.user.idClienteSAP,
                        material: "",//c.producto.material,
                        listaVigencia: this.list.cartItems,
                    };

                    this.price = 0;
                    this.moneda = "";
                    this.unidad = "";
                    this.idProductoCliente = 0;



                    let request = await this.$http.put(
                        route("Productos/getPrecioByMaterial"),
                        param
                    );

                    let producto = getResponse(request, null);

                    this.detalleProducto = producto;



                    if (this.detalleProducto.productos.length > 0) {

                        const today = new Date();
                        const yyyy = today.getFullYear();
                        let mm = today.getMonth() + 1; // month is zero-based
                        let dd = today.getDate();

                        if (dd < 10) dd = '0' + dd;
                        if (mm < 10) mm = '0' + mm;

                        let formatted = mm + '/' + dd + '/' + yyyy + ' 00:00:00';


                        for (let c of this.detalleProducto.productos) {

                            //console.log("Valor de c --> " + JSON.stringify(c));

                            if (c.idProductoCliente == 0) {

                                errors.push(c);
                            } else {


                                if (((Date.parse(c.fechaInicioValida) < Date.parse(formatted)) &&
                                    Date.parse(c.fechaFinValida) < Date.parse(formatted)) ||
                                    ((Date.parse(c.fechaInicioValida) > Date.parse(formatted)) &&
                                        Date.parse(c.fechaFinValida) > Date.parse(formatted))) {
                                    //console.log("FECHA FIN VALIDA CONVERTIDA -----------------> " + this.detalleProducto.productos[0].fechaFinValida);
                                    //console.log("FECHA FIN VALIDA CONVERTIDA -----------------> " + day);
                                    this.notifyMessage(
                                        "danger",
                                        this.$t("app.modules.product_family_detail.errors.no_validity") + c.material

                                    );

                                    messageError = true;

                                } else {


                                    if (c.isPrecioLista) {

                                        //Console.log("Entra a precio de lista");

                                        //console.log("IsPrecioLista -----------------> " + this.detalleProducto.productos[0].isPrecioLista);

                                        if (c.listaPrecio != c.listaPrecioCliente) {
                                            this.notifyMessage(
                                                "danger",
                                                this.$t("app.modules.product_family_detail.errors.unassociated_list_price") +
                                                c.material);

                                            messageError = true;
                                            /*
                                            throw new Error(
                                            this.$t("app.modules.product_family_detail.errors.unassociated_list_price")
                                        );*/

                                        } else {



                                            if (
                                                c.cantidadSolicitada >=
                                                c.cantidadMinimaPedido ||
                                                c.cantidadMinimaPedido == 0
                                            ) {

                                                /*console.log(
                                                    "lista producto.productos -->" +
                                                    JSON.stringify(producto.productos));*/

                                                if (producto && producto.productos.length > 0) {




                                                    //let _producto = pro.productos;
                                                    this.price = c.precioUnitario;
                                                    this.moneda = c.moneda;
                                                    this.unidad = c.unidadMedida;
                                                    this.idProductoCliente = c.idProductoCliente;
                                                    this.cantidadMinima = c.cantidadMinimaPedido;
                                                    validItems.push({
                                                        price: c.precioUnitario,
                                                        moneda: c.moneda,
                                                        unidad: c.unidadMedida,
                                                        idProductCliente: c.idProductoCliente,
                                                        cantidad: c.cantidadSolicitada,
                                                        cantidadMinima: c.cantidadMinima,
                                                        idCartItem: c.idCartItem,
                                                        idPedido: c.idPedido,
                                                        fechaEntrega: c.fechaEntrega,
                                                    });


                                                } else {
                                                    errors.push(c);
                                                }
                                            } else {
                                                this.notifyMessage(
                                                    "danger",
                                                    this.$t("app.modules.product_family_detail.errors.no_min_qty") +
                                                    ": " +
                                                    c.cantidadMinimaPedido +
                                                    " for the product " +
                                                    c.material
                                                );

                                                messageError = true;
                                            }

                                        }

                                    } else {


                                        //console.log("Entra a precio de lista *****");
                                        
                                        //console.log("ID de pedido : " + c.idPedido);

                                        if (
                                            c.cantidadSolicitada >=
                                            c.cantidadMinimaPedido ||
                                            c.cantidadMinimaPedido == 0
                                        ) {
                                            

                                            if (producto && producto.productos.length > 0) {




                                                //let _producto = producto.productos[0];
                                                this.price = c.precioUnitario;
                                                this.moneda = c.moneda;
                                                this.unidad = c.unidadMedida;
                                                this.idProductoCliente = c.idProductoCliente;
                                                this.cantidadMinima = c.cantidadMinimaPedido;
                                                validItems.push({
                                                    price: c.precioUnitario,
                                                    moneda: c.moneda,
                                                    unidad: c.unidadMedida,
                                                    idProductCliente: c.idProductoCliente,
                                                    cantidad: c.cantidadSolicitada,
                                                    cantidadMinima: c.cantidadMinima,
                                                    idCartItem: c.idCartItem,
                                                    idPedido: c.idPedido,
                                                    fechaEntrega: c.fechaEntrega,
                                                });

                                            } else {
                                                errors.push(c);
                                            }
                                        } else {
                                            this.notifyMessage(
                                                "danger",
                                                this.$t("app.modules.product_family_detail.errors.no_min_qty") +
                                                ": " +
                                                c.cantidadMinimaPedido +
                                                " for the product " +
                                                c.material
                                            );

                                            messageError = true;
                                        }

                                    }


                                }


                            }

                        }

                    } else {
                        if (!param.material) {
                            this.notifyMessage(
                                "danger",
                                this.$t("app.cart.promps.noMaterial")
                            );

                            messageError = true;

                        } else {
                            this.notifyMessage(
                                "danger",
                                this.$t("app.cart.promps.noPriceForProduct") +
                                ": " +
                                c.material
                            );

                            messageError = true;
                        }
                    }
                    //}

                    if (errors.length > 0) {
                        let partsNumbers = errors.map((item) => item.material);

                        this.notifyMessage(
                            "danger",
                            `
                ${this.$t("app.modules.add_by_part_number.product_not_cte")}
                :
                ${partsNumbers.join(", ")}
              `
                        );

                        messageError = true;
                    }
                }

                var fechatest = new Date();
                fechatest.setDate(fechatest.getDate() + 30);

                let itemsToCart = [];

                //console.log("******* ANTES DE VALIDITEMS *******");

                if (validItems.length > 0) {

                    //console.log("******* VALIDITEMS ES MAYOR A CERO *******");

                    //console.log("Valor de item --> " + JSON.stringify(validItems));

                    for (let key in validItems) {
                        try {

                            //console.log(key);
                            let item = validItems[key];

                            //console.log("Valor de item --> " + JSON.stringify(item));
                            //console.log(
                            // "Valor de item idProductCliente --> " + item.idProductCliente
                            //);
                            //console.log("Valor de item cantidad --> " + item.cantidad);

                            if (item.fechaEntrega == fechatest) {
                                item.fechaEntrega = fechatest;
                            }

                            let payload = {
                                idCartItem: item.idCartItem,
                                idProductoCliente: item.idProductCliente,
                                cantidad: item.cantidad,
                                fechaEntrega: item.fechaEntrega,
                                idPedido: item.idPedido,
                            };

                            if (!payload.idProductoCliente)
                                throw new Error(
                                    this.$t("app.modules.product_family_detail.errors.no_client")
                                );

                            if (!payload.cantidad)
                                throw new Error(
                                    this.$t("app.modules.product_family_detail.errors.no_quantity")
                                );
                            if (!payload.fechaEntrega)
                                throw new Error(
                                    this.$t(
                                        "app.modules.product_family_detail.errors.no_delivery_date"
                                    )
                                );



                            let product_ = await this.getProductDetail(
                                payload.idProductoCliente
                            );

                            
                            if (product_ !== null) {
                                
                                if (!product_.enriquecido) {
                                    
                                    throw new Error(
                                        this.$t("app.modules.product_family_detail.errors.no_details")
                                    );
                                } else {

                                    itemsToCart.push(payload);
                                }
                            } else {
                                throw new Error(
                                    this.$t(
                                        "app.modules.product_family_detail.errors.no_product_avilable"
                                    )
                                );
                            }
                        } catch (e) {
                            //console.log(e);
                            this.notifyMessage("danger", e.message);
                        } finally {
                            this.$swal.close();
                        }
                    }

                    

                    if (itemsToCart.length > 0) {

                        for (let item of itemsToCart) {


                            EventBus.$emit("update-cart-item", {
                                idCartItem: item.idCartItem,
                                cantidad: item.cantidad,
                                fechaEntrega: item.fechaEntrega,
                                idProductoCliente: item.idProductoCliente,
                                idPedido: item.idPedido,
                            });


                        }
                    } else {
                        this.$swal.close();
                    }
                } else {
                    this.$swal.close();
                }

                return messageError;

            }

        },
        async getProductDetail(id) {
            let item = false;

            const params = {
                idProducto: id,
            };
            //console.log(params);
            try {
                //console.log(params);
                let productoRequest = await this.$http.post(
                    route("Productos/getInformacionProductoID"),
                    params
                );

                let producto = getResponse(
                    productoRequest,
                    null,
                    (body) => body.producto
                );

                //console.log("producto --> + " + producto);
                producto = producto || null;

                this.detallesProducto = producto;
                item = producto;
                // this.handleProduct(this.producto);
            } catch (e) {
                console.error(e);
            }

            return item;
        },
    },
    watch: {
        files(value) {
            this.orden = value[0];
        },
    },
};
</script>

<style scoped>
.form-group .el-input__inner[readonly] {
    background-color: #b61515 !important;
}
</style>
